module.exports['c'] = require('./c')
module.exports['golang'] = require('./golang')
module.exports['php'] = require('./php')
module.exports['python'] = require('./python')
module.exports['ruby'] = require('./ruby')
